import React from "react";
var __jsx = React.createElement;
import TabbyForm from '../components/TabbyForm';
var TabbyFormPage = function TabbyFormPage() {
  return /*#__PURE__*/React.createElement(TabbyForm, null);
};
export default TabbyFormPage;